(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tab-content"] && !Shopify.designMode) return;
  try {
    
    jQuery(document).ready(function(){
        jQuery('.tab-menu li:first-child').addClass('active');
        if(jQuery('.tab-menu li').length > 1){
            jQuery('.tab-menu li').click(function(){
                jQuery('.tab-menu li').removeClass('active');
                jQuery(this).addClass('active')
                let tabId = jQuery(this).data('id');
                jQuery('.product-tab-content .product-tab-content-in .tab-content').fadeOut();
                setTimeout(function(){
                    jQuery('#'+tabId).fadeIn();
                },300)
            });
        }else{
            jQuery('.tab-menu li').addClass('no-handler');
        }
        $(".tab-menu li[data-id='feeding-instructions-tab']").addClass("active")
    });

  } catch(e) { console.error(e); }
})();
})();
